export default __webpack_public_path__ + "static/media/Chhattisgarhi_dm_2.fa1d7b50.mp3";